export default "/fonts/poppins-v9-latin-regular.woff2?5224cd4c8d93efc4fd95dfdeb613ab05";